import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import registerServiceWorker from './registerServiceWorker';

import { ThemeProvider } from '@material-ui/core/styles';
import { StylesProvider } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import theme from './theme';

const rootElement = document.getElementById('nibeQuoteRoot');

if (rootElement) {
    
    const { language, config, siteId } = rootElement.dataset;
    
    ReactDOM.render(
            <StylesProvider injectFirst>
                <ThemeProvider theme={theme}>
                    <CssBaseline />
                    <App {...{ language, config, siteId }} />
                </ThemeProvider>
            </StylesProvider>,
        rootElement);
}

registerServiceWorker();

